import { useECMAScriptNext } from './use-ecmascript-next';
import UglifyJS from './uglify-js-browser';
import babelTransform from './babelTransform';

export default async function minify(code) {
  if (useECMAScriptNext) return babelTransform(code);

  const { code: minified, error } = UglifyJS.minify(code);
  if (error) return babelTransform(code);
  return minified;
}
